import { ConfigData } from 'types/interfaces';

const config: ConfigData = {
  ID: 'PAYMENT_INFOS_STEP',
  SIDEBAR_MENU: true,
  PROGRESS_BAR: true,
  PROGRESS_BAR_COUNT: true,
  FOOTER: true,
  BUTTON_HELP: true,
  BUTTON_LANG: true,
  BUTTON_QUIT: true,
};

export default config;
